<table class="custom-table table table-striped" style="width: 100%" role="grid" aria-describedby="">
    <thead class="bg-primary">
        <tr class="casedata">
            <th>
                {{ "violationNumber" | translate }}
            </th>
            <th class="">
                {{'BasicInformation' | translate}}
            </th>
            <!-- <th>{{'CaseDate' | translate}}</th>
            <th> الاجراءات </th> -->
        </tr>
    </thead>
    <tbody>

        <!--| paginate  : {
        itemsPerPage: take,
        currentPage: page,
        totalItems: total
        };  let i = index-->
        <ng-container *ngFor="  let violation of violationList">

            <tr class="casedata">
                <td width="12%" class="text-center">
                    <div class="case-num">

                        <div class="col-12">
                            <p>
                                <i class="fa fa-calendar"></i>
                                <span> {{ violation.createdDate | toDateOnly }}</span>
                            </p>
                        </div>

                        <div *ngIf="violation.violationNo!=null &&  violation.caseFormattedNumber!='' "
                            style="font-weight:bold ; font-size: 13px;">
                            {{'violationNumber'|translate}} :
                            {{ violation.violationNo }}/{{ violation.year }}


                        </div>
                        <div *ngIf="violation.decisionNo!='' " style="font-weight:bold ; font-size: 13px;">

                            {{'decisionNumber'|translate}}: {{ violation.decisionNo }}

                        </div>


                        <!-- <span> {{ violation.year }}</span> -->
                    </div>

                    <br />

                    <div class="case-status btn btn-dark btn-sm" style="cursor:none !important;">
                        <span> {{ violation.applicationName }}</span>
                    </div>
                </td>

                <td>

                    <div class="row p-1">
                        <div class="col-12" *ngIf="violation.companyName != null && violation.companyName != ''">
                            <span class="text-dark" style="font-weight: bold;">{{ "CompanyName" | translate }} : </span>
                            <span class="text-secondary"> {{ violation.companyName }} </span><span
                                *ngIf="violation.crNumber">
                                -
                                {{"CRNo" | translate}} : {{violation.crNumber}}
                            </span>
                            <!--<br>-->

                            <!--<span class="text-dark" style="font-weight: bold;">{{ "violationDescription" | translate }} : </span>-->
                            <!--<span class="text-secondary">{{ violation.description }}</span>-->

                        </div>
                        <div class="col-12" *ngIf="violation.memberName != null && violation.memberName != ''">
                            <span class="text-dark" style="font-weight: bold;">{{ "OffenderName" | translate }} :
                            </span>
                            <span class="text-secondary"> {{ violation.memberName }} </span><span
                                *ngIf="violation.crNumber">
                                -
                                {{"NationalIdentity" | translate}} : {{violation.memberIdentityNumber}}
                            </span>
                            <br>


                            <!--<span class="text-dark" style="font-weight: bold;">{{ "violationDescription" | translate }} : </span>
                            <span class="text-secondary">{{ violation.description }}</span>-->

                        </div>



                    </div>

                    <div class="row p-1">

                        <!--<div class="col-3">
                            <span class="text-dark" style="font-weight: bold;">الاجراء المتخذ : </span>
                            <span class="text-secondary">{{ violation.actionTaken }}</span>
                        </div>

                        <div class="col-3">
                            <span class="text-dark" style="font-weight: bold;">{{ "Evidences" | translate }} : </span>
                            <span class="text-secondary"> {{ violation.evidences }}</span>
                        </div>-->
                        <div class="col-3">
                            <span class="text-dark" style="font-weight: bold;">{{ "objectionCounts" | translate }} :
                            </span>
                            <span class="text-secondary">{{ violation.objectionCounts }}</span>
                        </div>
                        <div class="col-3">
                            <span class="text-dark" style="font-weight: bold;">{{ "objectionDate" | translate }} :
                            </span>
                            <span> {{ violation.endDate | toDateOnly }}</span>

                        </div>
                    </div>


                    <div class="row p-1 col-12">
                        <!--<div class="col-3">
                            <span class="text-dark" style="font-weight: bold;">{{ "Questioning" | translate }} : </span>
                            <span class="text-secondary">{{ violation.questioning }}</span>
                        </div>-->
                        <div class="col-3">
                            <span class="text-dark" style="font-weight: bold;">{{ "allowObjection" | translate }} :
                            </span>
                            <span class="text-secondary" *ngIf="violation.allowObjection==true">نعم</span>
                            <span class="text-secondary" *ngIf="violation.allowObjection==false">لا</span>

                        </div>
                        <div class="col-3" *ngIf="violation.allowObjection==false">
                            <span class="text-dark">{{ "noteObjection" | translate }} : </span>
                            <span class="text-secondary">{{ violation.objectionNotes }}</span>

                        </div>
                        <div class="col-2"
                            *ngIf="!((violation.allowObjection==true && '${{ today | toDateOnly }}'< '${{ violation.endDate | toDateOnly }}') && (currentUserRoleId==2 || currentUserRoleId==8 || currentUserRoleId==100 ||currentUserRoleId==200))">
                        </div>


                        <div class="col-2"
                            *ngIf="((violation.allowObjection==true && '${{ today | toDateOnly }}'< '${{ violation.endDate | toDateOnly }}') && (currentUserRoleId==2 || currentUserRoleId==8 || currentUserRoleId==100 ||currentUserRoleId==200)&& violation.isAnyObjectionApproved!=true)">
                            <a style="float: left;" (click)="makeObjection(violation.eViolationId,addObjection)"
                                class="btn btn-outline-dark">
                                {{ "makeObjection" | translate }}
                            </a>
                        </div>

                        <div class="col-3" *ngIf="violation.isAnyObjectionApproved ==true">
                            <span class="acceptedobjection">
                                {{"ObjectionViolationAccepted" | translate}}</span>
                        </div>
                        <div class="col-2" *ngIf="violation.isAnyObjectionApproved ==null">
                        </div>
                        <div class="col-2">
                            <a style="float: left;"
                                (click)="GotoViolationDetails(violation.eViolationId,ViolationDetails)"
                                class="btn btn-outline-dark">

                                <i class="fa fa-eye"></i>
                                {{ "Details" | translate }}

                            </a>
                        </div>
                        <div class="col-2" *ngIf="violation.isContainObjections==true">
                            <a style="float: left;"
                                (click)="GotoObjectionsDetails(violation.eViolationId,ObjectionsDetails)"
                                class="btn btn-outline-dark">

                                <i class="fa fa-hand"></i>
                                {{ "Objections" | translate }}

                            </a>
                        </div>
                    </div>


                    <br />


                </td>



            </tr>
        </ng-container>
    </tbody>
</table>


<!--  التفاصيل  -->
<ng-template #ViolationDetails let-modal>
    <div class="modal-header" style="justify-content: space-between">
        <h4 class="modal-title" id="modal-basic-title">
            {{ "Show" | translate }}
        </h4>
        <i style="font-size: 20px" class="fa fa-close" (click)="modal.dismiss('Cross click')"></i>

    </div>
    <div class="modal-body text-right">


        <app-violation-details [loadDataFP]="loadViolationDetails"></app-violation-details>


    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
            {{ "Close" | translate }}
        </button>
    </div>
</ng-template>


<!-- عمل اعتراض -->
<ng-template #addObjection let-modal>
    <div class="modal-header" style="justify-content: space-between">
        <h4 class="modal-title" id="modal-basic-title">
            {{ "addObjection" | translate }}
        </h4>

        <i style="font-size: 20px" class="fa fa-close" (click)="modal.dismiss('Cross click')"></i>

    </div>
    <div class="modal-body text-center">
        <div class="row">
            <div class="form-group" *ngIf="IsReadonly==false">
                <div class="col-lg-12">
                    <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                        <label>{{'ObjectionAbout'|translate}}</label>
                    </div>
                    <ng-select [items]="MemberForViolations" [(ngModel)]="MemebrId"
                        (change)="selectMemberViolation($event)" [multiple]="false" [clearable]="false" bindLabel="text"
                        bindValue="id" class="form-control-select"></ng-select>
                </div>
                <div class="col-lg-12 mt-2">
                    <div class="divformlabel">
                        <label>{{ "Reasons" | translate }}</label>
                    </div>
                    <textarea [(ngModel)]="reasons" type="text" class="form-control" style="height: 100px;"></textarea>
                </div>
                <div class="col-lg-12 mt-2">
                    <div class="divformlabel">
                        <label>{{ "Requests" | translate }}</label>
                    </div>
                    <textarea [(ngModel)]="requests" type="text" class="form-control" style="height: 100px;"></textarea>
                </div>
            </div>

            <div class="form-group" *ngIf="IsReadonly==true">
                <div class="col-lg-12">
                    <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                        <label>{{'ObjectionAbout'|translate}}</label>
                    </div>
                    <ng-select [items]="MemberForViolations" [(ngModel)]="MemebrId"
                        (change)="selectMemberViolation($event)" [multiple]="false" [clearable]="false" bindLabel="text"
                        bindValue="id" class="form-control-select"></ng-select>
                </div>
                <div class="col-lg-12 mt-2">
                    <div class="divformlabel">
                        <label>{{ "Reasons" | translate }}</label>
                    </div>
                    <textarea readonly [(ngModel)]="reasons" type="text" class="form-control"
                        style="height: 100px;"></textarea>
                </div>
                <div class="col-lg-12 mt-2">
                    <div class="divformlabel">
                        <label>{{ "Requests" | translate }}</label>
                    </div>
                    <textarea readonly [(ngModel)]="requests" type="text" class="form-control"
                        style="height: 100px;"></textarea>
                </div>
            </div>
        </div>
        <div class="row m-2 col-12">
            <div class="col-4"></div>
            <div class="col-4">
                <button *ngIf="ObjectionByMemberAndViolation == null" type="button" class="btn btn-primary"
                    (click)="onCreateObjection()">
                    {{ "Save" | translate }}
                </button>
                <button *ngIf="ObjectionByMemberAndViolation && requestStatusId == 1" type="button"
                    class="btn btn-primary" (click)="onEditObjection()">
                    {{ "Edit" | translate }}
                </button>


            </div>
        </div>
        <div *ngIf="stepOneDone || stepTwoDone">
            <h4 class="mt-3">{{ "Attachments" | translate }}</h4>
            <hr>
            <div class="row">
                <div class="col-5 mt-2 " style="display: flex;">
                    <button class="btn btn-primary" (click)="upload(createAtt);" href="javascript:void(0);">
                        <i class="fa fa-plus-circle"></i>
                        <span> {{'AddAttachment' | translate}} </span>
                    </button>
 
                    <button class="btn btn-primary ml-1" (click)="scan(openScannerModel);" >
                        <i class="fa fa-plus-circle"></i>
                        <span> {{'Scanner' | translate}} </span>
                    </button>
                    </div>
                <div class="col-6"></div>

                <div>

                    <table class="table table-striped mt-3" *ngIf="AttachmentList">
                        <thead class="bg-primary">
                            <tr>
                                <th>{{'fileName'|translate}}</th>
                                <th>{{'AttachmentType'|translate}}</th>

                                <th>{{'Actions' | translate}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let att of AttachmentList">

                                <td class="p-3">{{ att.fileName}}</td>
                                <!-- <td class="p-3">{{ att.fileType}}</td> -->
                                <td class="p-3"  *ngIf="att.attachmentTypeId!=100" >{{ att.attachmentTypeName ? att.attachmentTypeName :'-' }}</td>
                                <td class="p-3" *ngIf="att.attachmentTypeId ==100">{{ att.otherName}}</td>

                                <td class="p-3">
                                    <a (click)="download2(att);" class="btn btn-sm btn-outline-primary ms-1 pb-0">
                                        <app-feather-icons [icon]="'download'"></app-feather-icons>
                                    </a>
                                    <a *ngIf="att.fileType=='image/jpeg' || att.fileType=='image/jpg' || att.fileType=='image/png' || att.fileType=='application/pdf'"
                                        (click)="previewPDF2(att,pdfViewer)"
                                        class="btn btn-sm btn-outline-dark ms-1 pb-0">
                                        <app-feather-icons [icon]="'eye'"></app-feather-icons>
                                    </a>
                                    <a *ngIf="att.createdBy==currentUserId"
                                        (click)="DeletePhisicalAttachment(att, confirmPhisicalAttach);"
                                        class="btn btn-sm btn-outline-danger ms-1 pb-0">
                                        <app-feather-icons [icon]="'trash'"></app-feather-icons>
                                    </a>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>





            <!-- اضافة مرافق -->
            <ng-template #createAtt let-modal>
                <div class="modal-header" style="justify-content: space-between">
                    <div></div>
                    <h4 class="modal-title" id="modal-basic-title">
                        {{ 'AddAttachment' | translate }}
                    </h4>

                    <i style="font-size: 20px;" class="fa fa-close" (click)="modal.dismiss('Cross click');"></i>
                </div>
                <div class="modal-body">
                    <div class="custom-form ">
                        <div class="col-12 offset-1">
                            <div class="card p-3">
                                <div class="form-group mt-3 row">
                                    <div class="form-group ">
                                        <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                            <label>{{ "AttachmentType" | translate }}</label>
                                            <span *ngIf="AttachType.invalid" class="alert" style="
                                                    color: red;
                                                    white-space: nowrap;
                                                    line-height: 0;
                                                    padding: 0;
                                                    margin-top: 8px;
                                                  ">
                                                <div *ngIf="AttachType.errors?.required">*</div>
                                            </span>
                                        </div>
                                        <ng-select id="AttachType" required #AttachType="ngModel"
                                            class="form-control-select" [items]="atachTypesArr" bindLabel="text"
                                            bindValue="id" [(ngModel)]="attachmentTypeId"
                                            [ngModelOptions]="{ standalone: true }"
                                            placeholder="{{ 'AttachmentType' | translate }}">
                                        </ng-select>
                                    </div>
                                    <div class="form-group mt-3" *ngIf="attachmentTypeId==100">
                                        <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                            <label>{{ "otherTypeInfo" | translate }}</label>
                                            <span *ngIf="otherTypeInfo==undefined ||  otherTypeInfo==''" class="alert"
                                                style="color: red; white-space: nowrap;line-height: 0; padding: 0; margin-top: 8px;">
                                                <div *ngIf="otherTypeInfo==undefined ||  otherTypeInfo=='' ">
                                                    *
                                                </div>
                                            </span>
                                        </div>
                                        <input [(ngModel)]="otherTypeInfo" type="text" class="form-control" />
                                    </div>
                                    <div class="form-group mt-3 row">
                                        <div class="col-8">
                                            <div style="display: flex; flex-wrap: nowrap; height: 30px">
                                                <label>{{ "Attachment" | translate }}</label>
                                                <span *ngIf="selectedFile ==undefined" class="alert" style="
                                          color: red;
                                          white-space: nowrap;
                                          line-height: 0;
                                          padding: 0;
                                          margin-top: 8px;
                                        ">
                                                    <div *ngIf="selectedFile ==undefined">*</div>
                                                </span>
                                            </div>
                                            <input type="file" (change)="selectFile($event)"
                                                accept=".mp4,.mp3,avi,.mpeg,.dat,.xlsx,.xltx,.pptx,.pdf,.doc,.docx,image/*,application/msword" />
                
                                        </div>
                                        <div *ngIf="Loader" class="loader col-2"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer row" style="justify-content: space-between;padding: 1rem 2rem;">
                    <button (click)="UploadFile(modal)" [disabled]=" selectedFile == undefined"
                        style="color: black;font-weight: bold;" type="button" class="btn btn-primary col-lg-3"
                        data-bs-dismiss="modal">
                        {{"Add" | translate}}
                    </button>
                    <button type="button" class="btn btn-dark col-lg-3" (click)="modal.dismiss('Cross click');">
                        {{ "Close" | translate }}
                    </button>
                </div>
            </ng-template>
        </div>
        <div *ngIf="(stepOneDone || stepTwoDone)">
            <div class="form-group row">
                <hr class="mb-3" />
                <div class="col-lg-12">
                    <div class="custom-control custom-checkbox" style="display: flex; align-items: center">
                        <input (change)="checkConfirm(allowSend)" [(ngModel)]="allowSend" type="checkbox" />
                        <label style="margin-top: 4px">
                            <span>
                                {{'confirmObjection'|translate}}
                            </span>
                        </label>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button *ngIf="(stepOneDone || stepTwoDone)" [disabled]="!allowSend" type="button" class="btn btn-primary"
            (click)="onSendObjection(modal)">
            {{ "Send" | translate }}
        </button>
        <button type="button" class="btn btn-danger col-lg-3" (click)="modal.dismiss('Cross click')">
            {{ "Close" | translate }}
        </button>
    </div>
</ng-template>
<!--  الاعتراض  -->
<ng-template #ObjectionsDetails let-modal>
    <div class="modal-header" style="justify-content: space-between">
        <h4 class="modal-title" id="modal-basic-title">
            {{ "Objections" | translate }}
        </h4>
        <i style="font-size: 20px" class="fa fa-close" (click)="modal.dismiss('Cross click')"></i>

    </div>
    <div class="modal-body text-right">

        <div class="container-fluid">

            <div class="row col-12">
                <div class="card-body">
                    <table class="table table-striped">
                        <thead class="bg-primary">
                            <tr>
                                <th scope="col">{{'ObjectionNumber' | translate }}</th>
                                <th scope="col">{{'TheNameOfThePetitioner' | translate }}</th>

                                <th scope="col">{{'RequestStatus' | translate }}</th>
                                <th scope="col">{{'Requests' | translate }} و {{ "Reasons" | translate }}
                                </th>
                                <th scope="col">{{'action' | translate }}</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of ViolationObjections">

                                <td>
                                    {{ item.requestId }}
                                </td>
                                <td>
                                    {{ item.member.name }}
                                </td>
                                <td>
                                    {{ item.requestStatusName }}
                                </td>

                                <td>
                                    <p><span style="font-weight: bold;">{{'Requests' | translate }}:</span>{{
                                        item.requests }}</p>
                                    <p><span style="font-weight: bold;">{{'Reasons' | translate }}:</span>{{
                                        item.reasons }}</p>
                                </td>
                                <td>

                                    <a (click)="GotoObjectionsViolationDetails(item.eRequestId,modal)"
                                        class="btn btn-outline-dark">
                                        <i class="fa fa-eye"></i>
                                        {{ "Details" | translate }}

                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
            {{ "Close" | translate }}
        </button>
    </div>
</ng-template>


<ng-template #openScannerModel let-modal>
    <div class="modal-header" style="justify-content: space-between">
        <div></div>
        <h4 class="modal-title" id="modal-basic-title">
            {{ 'Scanner' | translate }}
        </h4>

        <i style="font-size: 20px;" class="fa fa-close" (click)="modal.dismiss('Cross click');"></i>
    </div>
    <div class="modal-body">
        <div class="custom-form ">
            <app-scanner *ngIf="isScan" [eObjectionRequestId]="eObjectionRequestId" 
                [attachTypesArr]="atachTypesArr" (HideMe)="hidescan(modal);" [hidden]="!isScan"   [isinternal]="'false'"
                (SaveScan)="reloadAfterScan();" [loadscanner]="loadscanner"></app-scanner>
        </div>
    </div>
</ng-template>





<ng-template #pdfViewer let-modal>

    <div class="modal-body text-center">


        <div style="position:absolute; top:40%; left:45%;  z-index:-1;">
            <div class="spinner-border text-success" role="status">
            </div>
            <br />
            <br />
            <span> {{'uploadFile'|translate}} ...</span>
        </div>
        <i (click)="modal.dismiss('Cross click')" style="position: absolute;z-index: 1;left: 45px;font-size: 25px;"
           class="fa fa-close"></i>

        <!-- -->
        <pdf-viewer *ngIf="pdfFile" [src]="doc" [render-text]="true" [original-size]="false" [show-all]="true"
                    [show-borders]="true">


        </pdf-viewer>

        <img style="width:100%;" *ngIf="!pdfFile" [src]="image" alt="">
    </div>
</ng-template>